<script setup>
import {computed} from 'vue'
import {useRoute} from 'vue-router'
import ComponentSettingsBtn from './component-settings/ComponentSettingsBtn'
import ComponentFieldsBtn from './component-fields/ComponentFieldsBtn'

const route = useRoute()

// --- Computed ---

const routeName = computed(() => {
    return route.name
})

const tableName = computed(() => {
    return route.params.component
})
</script>

<template>
    <div class="d-flex align-items-center">
        <ComponentSettingsBtn
            v-if="tableName"
            :class="{ 'active': routeName === 'componentSettings' }"
            :table-name="tableName"
            class="me-1"
        />

        <ComponentFieldsBtn
            v-if="tableName"
            :class="{ 'active': routeName === 'componentFields' }"
            :table-name="tableName"
        />
    </div>
</template>

<style scoped>
/* Scoped styles preserved */
.active {
    /* Assuming some active styling was intended here */
    background-color: var(--bs-light);
    border-color: var(--bs-gray-400);
}
</style>